import moment from "moment";
import { globals, page as pageIndex } from "../../globals";
import { logOut } from "./auth";
import { returnDateFormat } from "./helpers";
import { hideModal, showModal } from "./modal";
import { clearHistory, saveInitialValues } from "./undo";
import { actionHandler } from "./updateData";
// ------------------------------------
// Constants
// ------------------------------------
const UPDATE_DATA = "UPDATE_DATA";
export const UPDATE_URL_DATA = "UPDATE_URL_DATA";
export const GET_LOCAL_QUEUE_START = "GET_LOCAL_QUEUE_START";
export const GET_LOCAL_QUEUE_FETCHED = "GET_LOCAL_QUEUE_FETCHED";
export const GET_LOCAL_QUEUE_FAILURE = "GET_LOCAL_QUEUE_FAILURE";
export const GET_LOCAL_RECORD_START = "GET_LOCAL_RECORD_START";
export const GET_LOCAL_RECORD_FETCHED = "GET_LOCAL_RECORD_FETCHED";
export const GET_LOCAL_RECORD_FAILURE = "GET_LOCAL_RECORD_FAILURE";
export const OPEN_LOCAL_RECORD = "OPEN_LOCAL_RECORD";
export const RETURN_DEFAULT = "RETURN_DEFAULT";
export const SAVE_LOCAL_RECORD_START = "SAVE_LOCAL_RECORD_START";
export const LOCAL_RECORD_SAVED = "LOCAL_RECORD_SAVED";
export const SAVE_LOCAL_RECORD_FAILURE = "SAVE_LOCAL_RECORD_FAILURE";
export const GET_BACKGROUND_QUEUE_FETCHED = "GET_BACKGROUND_QUEUE_FETCHED";
export const FILTER_RECORDS_BY_REGION = "FILTER_RECORDS_BY_REGION";
// ------------------------------------
// Actions
// ------------------------------------
export function updateUrlData(location, valueType, valueID, fieldValue) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_URL_DATA,
      location,
      valueType,
      payload: {
        value: valueID,
        fieldValue: fieldValue,
      },
    });
  };
}

const headers = {
  "Content-Type": "application/json",
};

function returnTypesForQueue(types) {
  if (types) {
    return types.map((item) => `&notestypes=${item}`).join("");
  } else return "";
}

export function getLocalReviewQueue(
  actionType,
  dateSearch,
  searchTerm,
  notesTypes,
  forcedLocality
) {
  return (dispatch) => {
    dispatch({ type: GET_LOCAL_QUEUE_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    const newDateSearch =
      dateSearch && dateSearch !== " " && dateSearch !== "Invalid date"
        ? `&searchdate=${moment(dateSearch).format("YYYY-MM-DD")}`
        : "";
    const newSearchTerm = searchTerm ? `&searchterm=${searchTerm}` : "";
    const newTypes = returnTypesForQueue(notesTypes);
    fetch(
      `${globals.apiUrl}/localreview?actiondatetype=${actionType}${newDateSearch}${newSearchTerm}${newTypes}`,
      options
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          return dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LOCAL_QUEUE_FETCHED,
            payload: {
              json,
              newDateSearch,
            },
          });
          if (json.length === 0) {
            dispatch(showModal("No-results"));
            dispatch({ type: RETURN_DEFAULT });
          } else if (json.length !== 0) {
            let index = 0;
            if (forcedLocality) {
              const foundForcedIndex = json.findIndex((record) => {
                return record.Locality === forcedLocality;
              });

              if (foundForcedIndex !== -1) {
                index = foundForcedIndex;
              }
            }
            const localReviewId = json[index].LocalReviewId;

            dispatch(getLocalReviewRecord(localReviewId, actionType, index));
          }
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LOCAL_QUEUE_FAILURE });
      });
  };
}

export function getBackGroundQueue(
  actionType,
  dateSearch,
  searchTerm,
  notesTypes,
  openParameters
) {
  return (dispatch) => {
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    const newDateSearch = dateSearch ? `&searchdate=${dateSearch}` : "";
    const newSearchTerm = searchTerm ? `&searchterm=${searchTerm}` : "";
    const newTypes = returnTypesForQueue(notesTypes);
    return fetch(
      `${globals.apiUrl}/localreview?actiondatetype=${actionType}${newDateSearch}${newSearchTerm}${newTypes}`,
      options
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          return dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LOCAL_QUEUE_FETCHED,
            payload: {
              json,
            },
          });
          dispatch({ type: "WAIT_FOR_QUEUE_SUCCESS" });
          if (openParameters && openParameters.LocalReviewId) {
            const index = json.findIndex(
              (elem) => elem.LocalReviewId === openParameters.LocalReviewId
            );
            dispatch(openLocalRecord(json[index], index + 1, actionType));
          }
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LOCAL_QUEUE_FAILURE });
      });
  };
}

export function getLocalReviewRecord(recordId, actionType, index) {
  return (dispatch) => {
    dispatch({ type: GET_LOCAL_RECORD_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    if (!recordId) {
      return dispatch({ type: GET_LOCAL_RECORD_FAILURE });
    }
    fetch(
      `${globals.apiUrl}/localreview/${recordId}?actiondatetype=${actionType}`,
      options
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          return dispatch(logOut());
        } else {
          dispatch({ type: GET_LOCAL_RECORD_FAILURE });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LOCAL_RECORD_FETCHED,
            payload: {
              json,
              index: index,
            },
          });
          dispatch(hideModal("Loading-modal"));
          dispatch(hideModal("Duplicate-modal"));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LOCAL_RECORD_FAILURE });
      });
  };
}

export function saveLocalRecordChanges(
  parameters,
  trackData,
  advanceOption,
  openParameters,
  localities,
  getQueue
) {
  return (dispatch) => {
    dispatch({ type: SAVE_LOCAL_RECORD_START });
    const options = {
      method: "PUT",
      credentials: "include",
      headers,
      body: JSON.stringify(parameters),
    };
    const actionType = trackData.queryLine.radio.query;
    fetch(`${globals.apiUrl}/localreview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 400) {
          return response.text().then((text) => {
            if (text.includes("Please refresh data")) {
              dispatch(showModal("Time-out-modal"));
            }
          });
        } else if (response.status === 401) {
          return dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: LOCAL_RECORD_SAVED,
            payload: {
              json,
            },
          });
          if (!advanceOption) {
            const index = localities.findIndex(
              (elem) =>
                elem.LocalReviewId === openParameters.sponsorBill.LocalReviewId
            );
            dispatch(openLocalRecord(localities[index], index + 1, actionType));
          }
          if (getQueue) {
            const record = { LocalReviewId: json.Id };
            dispatch(getBackGroundQueue(actionType, null, null, null, record));
          }
          if (localStorage.getItem("signOut")) {
            dispatch(logOut());
            localStorage.removeItem("signOut");
          }
          dispatch(clearHistory(pageIndex.localReview));
          dispatch(saveInitialValues(pageIndex.localReview, trackData));

          if (advanceOption === "noAdvance") {
            dispatch(
              getLocalReviewRecord(
                parameters.Id,
                trackData.queryLine.radio.query,
                openParameters.record
              )
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SAVE_LOCAL_RECORD_FAILURE });
      });
  };
}

export function openLocalRecord(record, index, actionType, allRecords) {
  if (record && actionType !== null) {
    return (dispatch) => {
      dispatch(getLocalReviewRecord(record.LocalReviewId, actionType, index));
    };
  } else if (allRecords.length === 0) {
    return (dispatch) => {
      dispatch(showModal("No-results"));
      dispatch({ type: RETURN_DEFAULT });
    };
  } else {
    return {
      type: RETURN_DEFAULT,
    };
  }
}

export function filterRecordByRegion(regionType, allRecords) {
  const newRecords =
    regionType === "0"
      ? allRecords
      : allRecords.filter((item) => item.PriorityZone === +regionType);
  if (newRecords.length !== 0) {
    return {
      type: FILTER_RECORDS_BY_REGION,
      newRecords,
    };
  } else {
    return (dispatch) => {
      dispatch(showModal("No-results"));
      dispatch({ type: RETURN_DEFAULT });
    };
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA]: (state, action) =>
    action.location.page !== pageIndex.localReview
      ? state
      : actionHandler(state, action),
  [UPDATE_URL_DATA]: (state, action) => {
    const { page, field, id } = action.location;
    const { value, fieldValue } = action.payload;
    switch (action.valueType) {
      case "select":
      case "radio": {
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            [page]: {
              ...state.formDataValue[page],
              [field]: {
                ...state.formDataValue[page][field],
                [id]: {
                  ...state.formDataValue[page][field][id],
                  radio: {
                    ...state.formDataValue[page][field][id].radio,
                    [value]: fieldValue,
                  },
                },
              },
            },
          },
        };
      }
      case "textinput": {
        // set text value
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            [page]: {
              ...state.formDataValue[page],
              [field]: {
                ...state.formDataValue[page][field],
                [id]: {
                  ...state.formDataValue[page][field][id],
                  textValues: {
                    ...state.formDataValue[page][field][id].textValues,
                    [value]: fieldValue,
                  },
                },
              },
            },
          },
        };
      }
    }
  },
  [GET_LOCAL_QUEUE_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LOCAL_QUEUE_FETCHED]: (state, action) => {
    const { newDateSearch } = action.payload;
    const region = +state.formDataValue.OR.localRegionType.radio.region;

    const json = action.payload.json.map((locality) => {
      return {
        ...locality,
        value: locality.Locality,
        label: locality.Locality,
        activeFlag: locality.DeleteDate ? false : true,
      };
    });

    const filteredJson = Array.isArray(json)
      ? json.filter((item) => {
          if (region === 0) {
            return item;
          } else return item.PriorityZone === region;
        })
      : [];

    return {
      ...state,
      isFetchingData: false,
      disableEditing: json.length === 0,
      renderData: {
        ...state.renderData,
        amountOfRecords:
          region === 0 && json.length !== 0
            ? json
            : region !== 0 && json.length !== 0
            ? filteredJson
            : 0,
        localities:
          region === 0 && json.length !== 0
            ? json
            : region !== 0 && json.length !== 0
            ? filteredJson
            : [],
        allRecords: json,
      },
      formDataValue: {
        OR: {
          ...state.formDataValue.OR,
          localityDD: {
            radio: {
              locality:
                region === 0 && json.length !== 0
                  ? json[0].Locality
                  : region !== 0 && json.length !== 0 && filteredJson[0]
                  ? filteredJson[0].Locality
                  : "Selecte Locality",
            },
          },
          navigation: {
            textValues: {
              currentRecord: 1,
            },
          },
          queryLine: {
            ...state.formDataValue.OR.queryLine,
            dateTime: {
              filterDate: newDateSearch
                ? state.formDataValue.OR.queryLine.dateTime.filterDate
                : " ",
            },
            selected: state.formDataValue.OR.queryLine.selected.filter(
              (item) => typeof item === "string"
            ),
          },
        },
      },
    };
  },
  [FILTER_RECORDS_BY_REGION]: (state, action) => {
    const { newRecords } = action;
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        amountOfRecords: newRecords,
        localities: newRecords,
      },
      formDataValue: {
        OR: {
          ...state.formDataValue.OR,
          localityDD: {
            radio: {
              locality: newRecords[0].Locality,
            },
          },
        },
      },
    };
  },
  [GET_LOCAL_RECORD_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LOCAL_RECORD_FETCHED]: (state, action) => {
    const { json, index } = action.payload;
    const newIndex = state.renderData.localities.findIndex(
      (item) => item.LocalReviewId === json.Id
    );
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        localReviewRecord: json,
        openedRecord: index,
      },
      formDataValue: {
        OR: {
          ...state.formDataValue.OR,
          navigation: {
            textValues: {
              currentRecord: !index ? newIndex : index + 1,
            },
          },
          localityDD: {
            radio: {
              locality: `${json.State}:${json.LocalityName}`,
            },
          },
          localityNotes: {
            textValues: {
              meetingDates: json.MeetingDates || "",
              daysInAdvance: json.DaysInAdvance || "",
              agendaClients: json.Clients || "",
              minutesClient: json.MinutesClients || "",
              committeeReview: json.CommitteeReview || "",
            },
          },
          textBlocks: {
            textValues: {
              contactInfo: json.ContactInformation || "",
              localityNotes: json.Notes || "",
              agendas: json.AgendaNotes || "",
              specialAgendas: json.SpecialAgendaNotes || "",
              minutes: json.MinutesNotes || "",
              ordinances: json.OrdinanceNotes || "",
              rfp: json.RfpNotes || "",
              log: json.ReviewHistory || "",
            },
          },
          dates: {
            dateTime: {
              agendas: returnDateFormat(json.AgendasNextActionDate),
              minutes: returnDateFormat(json.MeetingsNextActionDate),
              rfp: returnDateFormat(json.RFPsNextActionDate),
              specialAgendas: returnDateFormat(
                json.SpecialAgendasNextActionDate
              ),
              ordinances: returnDateFormat(json.OrdinancesNextActionDate),
            },
          },
        },
      },
    };
  },
  [RETURN_DEFAULT]: (state) => {
    return {
      ...initialState,
      isFetchingData: false,
      disableEditing: false,
      renderData: {
        ...state.renderData,
      },
      formDataValue: {
        OR: {
          ...initialState.formDataValue.OR,
          queryLine: {
            ...state.formDataValue.OR.queryLine,
          },
          url: {
            0: {
              radio: {
                urlType: "type",
              },
              textValues: {
                urlInput: "",
              },
            },
          },
        },
      },
    };
  },
  [LOCAL_RECORD_SAVED]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        savedRecord: json,
      },
    };
  },
  LOCALITY_DELETED: (state, action) => {
    const { localityId } = action.payload;
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        amountOfRecords: state.renderData.amountOfRecords.filter(
          (item) => item.LocalReviewId !== localityId
        ),
        localities: state.renderData.localities.filter(
          (item) => item.LocalReviewId !== localityId
        ),
      },
    };
  },
  CLEAR_ADD_URL_MODAL: (state) => {
    return {
      ...state,
      formDataValue: {
        OR: {
          ...state.formDataValue.OR,
          url: {
            ...state.formDataValue.OR.url,
            0: {
              radio: {
                urlType: "type",
              },
              textValues: {
                urlInput: "",
              },
            },
          },
        },
      },
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: "",
  isFetchingData: true,
  renderData: {},
  formDataValue: {
    OR: {
      queryLine: {
        radio: {
          query: 0,
        },
        textValues: {
          keywordSearch: "",
        },
        selected: [],
        dateTime: {
          filterDate: " ",
        },
      },
      localityDD: {
        radio: {
          locality: "select locality",
        },
      },
      statesDD: {
        radio: {
          states: "select state",
        },
        textValues: {
          locality: "",
        },
      },
      localRegionType: {
        radio: {
          region: "0",
        },
      },
      url: {
        0: {
          radio: {
            urlType: "type",
          },
          textValues: {
            urlInput: "",
          },
        },
      },
      dates: {
        dateTime: {
          agendas: " ",
          minutes: " ",
          rfp: " ",
          specialAgendas: " ",
          ordinances: " ",
        },
      },
      localityNotes: {
        textValues: {
          meetingDates: "",
          daysInAdvance: "",
          agendaClients: "",
          minutesClient: "",
          committeeReview: "",
        },
      },
      navigation: {
        textValues: {
          currentRecord: "1",
        },
      },
      textBlocks: {
        textValues: {
          contactInfo: "",
          localityNotes: "",
          agendas: "",
          specialAgendas: "",
          minutes: "",
          ordinances: "",
          rfp: "",
          log: "",
        },
      },
    },
  },
};
export default function localReviewReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/localReviewData.js